<template>
    <div v-if="loaded">
        <header-content :files="files" :title="currentLoadedContent.translation?.name"></header-content>
        <div class="container mt--7">
            <div class="row">
                <div class="col xs-8">
                    <div class="card px-3 py-4">
                        <component :is="contentType" :data="currentLoadedContent" />
                    </div>
                </div>
            </div>
            <!-- Seção inferior também no acesso anônimo (backlog#410): Visão
                 Geral e Material de apoio (downloads assinados); o Fórum fica
                 restrito a usuários logados (TabOptions trata via isPublic). -->
            <TabOptions :lesson="lesson" :is-public="isPublic"/>
        </div>
    </div>
</template>

<script>
import HeaderContent from './LessonContentComponents/LessonContentHeader';
import ContentImage from './LessonContentUpload/ContentImage';
import ContentVideo from './LessonContentUpload/ContentVideo';
import ContentAudio from './LessonContentUpload/ContentAudio';
import ContentPDF from './LessonContentUpload/ContentPDF';
import ContentUndefinedFile from './LessonContentUpload/ContentUndefinedFile';
import TabOptions from '../Common/TabOptions/TabOptions';

export default {
    name: 'LessonContentUpload',
    components: {
        HeaderContent,
        ContentImage,
        ContentVideo,
        ContentAudio,
        ContentPDF,
        ContentUndefinedFile,
        TabOptions,
    },
    data() {
        return {
            data: [],
            loaded: false,
            files: [],
        };
    },
    props: {
        contentId: {
            type: Number,
            required: true,
        },
        lesson: {
            type: Object,
            required: true,
        },
        id: Number,
        isPublic: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        contentId(newVal) {
            this.getContent(newVal);
        },
    },
    computed: {
        language() {
            return this.$store.getters.LANGUAGE;
        },
        contentType() {
            if (this.data.type_file === 'image') return 'ContentImage';
            else if (this.data.mime === 'video/mp4') return 'ContentVideo';
            else if (this.data.mime === 'audio/mpeg') return 'ContentAudio';
            else if (this.data.mime === 'application/pdf') return 'ContentPDF';
            return 'ContentUndefinedFile';
        },
        currentLoadedContent() {
            return this.$store.getters.LOADED_CONTENT;
        },
    },
    methods: {
        getContent(contentId) {
            // Primeiro, verificar se temos URLs assinadas no localStorage para este conteúdo
            const signedUrls = localStorage.getItem(`content_${contentId}_download_urls`);

            // Se estamos em uma aula pública ou plano público, tentamos usar a URL assinada primeiro
            if ((this.lesson.public || window.location.pathname.includes('/app/public/') || this.isPublic) && signedUrls) {
                this.$loading.show();

                // Usar a rota normal com o parâmetro lessonPublic=true
                return window.axios
                    .get(`/api/app/lesson/${this.lesson.id}/content/${contentId}/public`)
                    .then((res) => {
                        this.data = res.data;
                    })
                    .catch(err => console.error(err))
                    .finally(() => {
                        this.$loading.close();
                        this.loaded = true;
                    });
            }

            const publicContent = (this.lesson.public || this.isPublic) ? '/public' : '';
            this.$loading.show();

            // Verifica se a aula ou plano é público e caso seja, chama a rota pública
            return window.axios
                .get(`/api/app/lesson/${this.lesson.id}/content/${contentId}${publicContent}`, {
                    params: {
                        lessonPublic: !!(this.lesson.public || this.isPublic),
                    },
                })
                .then((res) => {
                    this.data = res.data;
                })
                .catch(err => console.error(err))
                .finally(() => {
                    this.$loading.close();
                    this.loaded = true;
                });
        },
    },
    mounted() {
        this.getContent(this.contentId);
        this.$emit('contentSubmited');
    },
};
</script>

<style>

</style>
